/**
 * SMA of True Range — same construction as live `useAtr` (not Wilder).
 */
function px(bar, field) {
  if (!bar) return null;
  const aliases = {
    close: ['close', 'Close'],
    high: ['high', 'High'],
    low: ['low', 'Low'],
  };
  for (const key of aliases[field] || [field]) {
    const n = typeof bar[key] === 'number' ? bar[key] : parseFloat(bar[key]);
    if (Number.isFinite(n)) return n;
  }
  return null;
}

export function trueRanges(bars) {
  const trs = new Array((bars || []).length).fill(null);
  if (!bars?.length) return trs;
  const h0 = px(bars[0], 'high');
  const l0 = px(bars[0], 'low');
  trs[0] = Number.isFinite(h0) && Number.isFinite(l0) ? h0 - l0 : null;
  for (let i = 1; i < bars.length; i++) {
    const h = px(bars[i], 'high');
    const l = px(bars[i], 'low');
    const cPrev = px(bars[i - 1], 'close');
    if (![h, l, cPrev].every(Number.isFinite)) continue;
    trs[i] = Math.max(h - l, Math.abs(h - cPrev), Math.abs(l - cPrev));
  }
  return trs;
}

export function atrFromBars(bars, period = 14) {
  const n = Math.max(1, Math.floor(Number(period) || 14));
  const trs = trueRanges(bars);
  const out = new Array(trs.length).fill(null);
  let sum = 0;
  let count = 0;
  for (let i = 0; i < trs.length; i++) {
    const tr = trs[i];
    if (!Number.isFinite(tr)) {
      out[i] = count > 0 ? sum / count : null;
      continue;
    }
    sum += tr;
    count += 1;
    const drop = i - n;
    if (drop >= 0 && Number.isFinite(trs[drop])) {
      sum -= trs[drop];
      count -= 1;
    }
    if (count > 0) out[i] = sum / count;
  }
  return out;
}
